import { ApiIntakeIntents } from 'api/types/ApiIntakeIntents';
import { postJson } from 'utils/http/postJson';

export type SaveUserDashboardIntakeIntentsResponse = {
  intakeIntents: Array<ApiIntakeIntents>;
  intakeIntentsDatetimeSet: string;
};

type Args = {
  intakeIntents: ApiIntakeIntents[];
  intakeIntentSomethingElse: string;
};

export function userDashboardApiSavePostingIntention({
  intakeIntents,
  intakeIntentSomethingElse,
}: Args): Promise<SaveUserDashboardIntakeIntentsResponse> {
  return postJson<SaveUserDashboardIntakeIntentsResponse>(
    '/data/userdashboard/intake-intents',
    {
      intakeIntents,
      intakeIntentSomethingElse,
    },
  );
}
